/// <reference types="@types/googlemaps" />
import { Component, ViewChild, EventEmitter, Output, OnInit, AfterViewInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'AutocompleteComponent',
    template: `
      <input class="input"
        type="text"
        [(ngModel)]="autocompleteInput"
        #addresstext style="width:400px;"
        >
    `,
    imports: [FormsModule]
})
export class AutocompleteComponent implements OnInit, AfterViewInit {
  @Input() addressType: string;
  @Input() streetControl: any;
  @Input() cityControl: any;
  @Input() stateControl: any;
  @Input() zipControl: any;
  @Input() latControl: any;
  @Input() lngControl: any;

    @Output() setAddress: EventEmitter<any> = new EventEmitter();
    @ViewChild('addresstext') addresstext: any;

    autocompleteInput: string;
    queryWait: boolean;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.getPlaceAutocomplete();
    }

    private getPlaceAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
            {
                componentRestrictions: { country: 'US' },
                types: [this.addressType]  // 'establishment' / 'address' / 'geocode'
            });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
           const place = autocomplete.getPlace();
           console.log(JSON.stringify(place));
           let addressParts = this.pushAddressParts(place);
           this.addresstext.nativeElement.value = '';
            this.invokeEvent(addressParts);
        });
    }

    invokeEvent(place: Object) {
        this.setAddress.emit(place);
    }

   pushAddressParts(data) {
      var addressParts = {
        street: this.getAddressPart(data, 'l', 'street_number') + ' ' + this.getAddressPart(data, 'l', 'route'),
        city: this.getAddressPart(data, 'l', 'locality'),
        state: this.getAddressPart(data, 's', 'administrative_area_level_1'),
        zip: this.getAddressPart(data, 's', 'postal_code'),
        lat: data.geometry.location.lat(),
        lng: data.geometry.location.lng()
      };

     if (addressParts.city == "") {
       addressParts.city = this.getAddressPart(data, 'l', 'sublocality');
     }

      if (this.streetControl != null) {
         this.streetControl.value = addressParts.street;
      }

      if (this.cityControl != null) {
         this.cityControl.value = addressParts.city;
      }

      if (this.stateControl != null) {
         this.stateControl.value = addressParts.state;
      }

     if (this.zipControl != null) {
         this.zipControl.value = addressParts.zip;
     }

     if (this.latControl != null) {
       this.latControl.value = addressParts.lat;
     }

     if (this.lngControl != null) {
       this.lngControl.value = addressParts.lng;
     }

      return addressParts;
   }

   //part = 'l' = Long, 's' = Short
   getAddressPart(data, part, key) {
      for (var i = 0; i < data.address_components.length; i++) {
         if (data.address_components[i].types.includes(key)) {
            if (part == 'l') {
               return data.address_components[i].long_name;
            } else {
               return data.address_components[i].short_name;
            }
         }
      }
      return '';
   }

}
